const applyConfig = (config) => config;
export default applyConfig;
